import { Action } from "redux";

import {
  CopyProjectRequest,
  GetAllProjectListByClientRequest,
} from "../request/project_request";

import {
  CopyProjectResponse,
  GetAllProjectListByClientResponse,
} from "../response/project_response";

export enum ClientProjectListActionType {
  REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST = "CLIENT_PROJECT_REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST",
  CALLBACK_GET_ALL_BY_CLIENT_PROJECT_LIST = "CLIENT_PROJECT_CALLBACK_GET_ALL_BY_CLIENT_PROJECT_LIST",

  REQUEST_COPY_PROJECT = "CLIENT_PROJECT_REQUEST_COPY_PROJECT",
  CALLBACK_COPY_PROJECT = "CLIENT_PROJECT_CALLBACK_COPY_PROJECT",
}

export interface IRequestGetAllByClientProjectListAction extends Action {
  type: ClientProjectListActionType.REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST;
  item: GetAllProjectListByClientRequest;
}
export interface ICallbackGetAllByClientProjectListAction extends Action {
  type: ClientProjectListActionType.CALLBACK_GET_ALL_BY_CLIENT_PROJECT_LIST;
  isSuccess: boolean;
  item?: GetAllProjectListByClientResponse;
}

export interface IRequestCopyProjectAction extends Action {
  type: ClientProjectListActionType.REQUEST_COPY_PROJECT;
  item: CopyProjectRequest;
}
export interface ICallbackCopyProjectAction extends Action {
  type: ClientProjectListActionType.CALLBACK_COPY_PROJECT;
  isSuccess: boolean;
  item?: CopyProjectResponse;
}

export type ClientProjectListAction =
  | IRequestGetAllByClientProjectListAction
  | ICallbackGetAllByClientProjectListAction
  | IRequestCopyProjectAction
  | ICallbackCopyProjectAction;

export interface IClientProjectListActionCreator {
  requestGetAllByClientProjectListAction(
    item: GetAllProjectListByClientRequest
  ): IRequestGetAllByClientProjectListAction;

  callbackGetAllByClientProjectListAction(
    isSuccess: boolean,
    items?: GetAllProjectListByClientResponse
  ): ICallbackGetAllByClientProjectListAction;

  requestCopyProjectAction(item: CopyProjectRequest): IRequestCopyProjectAction;

  callbackCopyProjectAction(
    isSuccess: boolean,
    items?: CopyProjectResponse
  ): ICallbackCopyProjectAction;
}

class ActionCreator implements IClientProjectListActionCreator {
  public requestGetAllByClientProjectListAction = (
    item: GetAllProjectListByClientRequest
  ): IRequestGetAllByClientProjectListAction => {
    return {
      type: ClientProjectListActionType.REQUEST_GET_ALL_BY_CLIENT_PROJECT_LIST,
      item,
    };
  };

  public callbackGetAllByClientProjectListAction = (
    isSuccess: boolean,
    item?: GetAllProjectListByClientResponse
  ): ICallbackGetAllByClientProjectListAction => {
    return {
      type: ClientProjectListActionType.CALLBACK_GET_ALL_BY_CLIENT_PROJECT_LIST,
      isSuccess,
      item,
    };
  };

  public requestCopyProjectAction = (
    item: CopyProjectRequest
  ): IRequestCopyProjectAction => {
    return {
      type: ClientProjectListActionType.REQUEST_COPY_PROJECT,
      item,
    };
  };

  public callbackCopyProjectAction = (
    isSuccess: boolean,
    item?: CopyProjectResponse
  ): ICallbackCopyProjectAction => {
    return {
      type: ClientProjectListActionType.CALLBACK_COPY_PROJECT,
      isSuccess,
      item,
    };
  };
}

export const createClientProjectListActionCreator =
  (): IClientProjectListActionCreator => {
    return new ActionCreator();
  };



// WEBPACK FOOTER //
// ./src/presentation/action/client_projects_action.ts